<template>
  <section
    id="quote"
    class="public-content"
    data-track-zone="quote"
  >
    <div class="mx-auto max-w-7xl px-6 md:px-12 xl:px-6">
      <div class="public-cta-band rounded-[var(--radius-section)] px-7 py-10 lg:px-12 lg:py-12">
        <div class="flex flex-wrap items-center justify-between gap-6 lg:flex-nowrap">
          <div class="text-center lg:text-left">
            <p class="mb-2 text-sm font-semibold text-brand-blue-100">
              Coordination médicale sur mesure
            </p>
            <h2 class="public-h2 text-white">
              Votre événement mérite un dispositif préventif solide.
            </h2>
            <p class="mt-3 max-w-2xl text-brand-blue-100 lg:text-lg">
              Nous construisons avec vous une présence médicale claire, réactive et conforme à votre réalité terrain.
            </p>
          </div>

          <NuxtLink
            to="/devis"
            rel="noopener"
            class="public-btn-inverse shrink-0"
          >
            Demander un devis
          </NuxtLink>
        </div>
      </div>
    </div>
  </section>
</template>
